export enum EAgriculturalProductDiscountType {
  FIXED = 'FIXED',
  FLOATING = 'FLOATING',
  NONE = 'NONE',
}
